var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccordion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 11,
    viewBox: "0 0 20 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4603 0.846069C19.3324 0.71711 19.1802 0.614753 19.0126 0.544901C18.8449 0.47505 18.6651 0.439087 18.4834 0.439087C18.3018 0.439087 18.122 0.47505 17.9543 0.544901C17.7866 0.614753 17.6345 0.71711 17.5066 0.846069L11.2051 7.14759C11.0771 7.27655 10.925 7.3789 10.7573 7.44875C10.5896 7.5186 10.4098 7.55457 10.2282 7.55457C10.0465 7.55457 9.86671 7.5186 9.69905 7.44875C9.53138 7.3789 9.37921 7.27655 9.2513 7.14759L2.94979 0.846069C2.82188 0.71711 2.66971 0.614753 2.50205 0.544901C2.33438 0.47505 2.15455 0.439087 1.97291 0.439087C1.79128 0.439087 1.61145 0.47505 1.44378 0.544901C1.27612 0.614753 1.12395 0.71711 0.996042 0.846069C0.739784 1.10386 0.595947 1.45258 0.595947 1.81606C0.595947 2.17955 0.739784 2.52827 0.996042 2.78606L7.31132 9.10133C8.08525 9.8743 9.13435 10.3085 10.2282 10.3085C11.322 10.3085 12.3711 9.8743 13.145 9.10133L19.4603 2.78606C19.7166 2.52827 19.8604 2.17955 19.8604 1.81606C19.8604 1.45258 19.7166 1.10386 19.4603 0.846069Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordion);
export default __webpack_public_path__ + "static/media/accordion.2fb2d2087e53da34069562d13cb00c4c.svg";
export { ForwardRef as ReactComponent };